<div class="dashboard__content mt-4 pb-5" [class.d-none]="!isLoaded">
    <div class="row mb-4 wh-breadcrumb g-0 text-uppercase">

        <div class="col-auto">
            <span class="small text-muted">Winning Hands Admin</span>
        </div>
        <div class="col-auto">
            <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
        </div>
        <div class="col-auto">
            <a [routerLink]="[ '/', 'admin', 'events' ]" class="small text-muted text-decoration-none"> Events</a>
        </div>
        <div class="col-auto">
            <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
        </div>
        <div class="col-auto">
            <a [routerLink]="[ '/', 'admin', 'events', eventDetail.eventID]"
                class="small text-muted text-decoration-none"> {{eventDetail.eventName}}</a>
        </div>
        <div class="col-auto">
            <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
        </div>
        <div class="col-auto">
            <a [routerLink]="[ '/', 'admin', 'events', eventDetail.eventID, 'therapists']"
                class="small text-primary text-decoration-none"> Therapists at event</a>
        </div>
    </div>


<div class="row mb-4">
        <div class="col">
        <h1 class="mb-0 text-uppercase">THERAPISTS AT {{eventDetail.eventName}}</h1>
    </div>
    <div class="col-auto">
         <button class="d-block d-lg-inline-block w-100" (click)="associateTherapist()" mat-flat-button color="primary">ASSOCIATE THERAPIST</button>
    </div>

</div>




<div class="row">
    <div class="col-12" style="width: 100%; overflow-x: auto;">
        <table matSort class="admin-table" mat-table [dataSource]="dataSource">


            <ng-container matColumnDef="image">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                    <img class="img-fluid rounded-pill" style="width: 40px; height: 40px; margin-right: 15px;"
                         src="{{getThumbURL(element.profileLargeURL)}}">
                </td>
            </ng-container>

            <ng-container matColumnDef="firstName">
                <th width="40%" mat-header-cell *matHeaderCellDef mat-sort-header>FIRST NAME</th>
                <td mat-cell *matCellDef="let element">{{element.therapistFirstName}} </td>
            </ng-container>
            <ng-container matColumnDef="lastName">
                <th  width="40%" mat-header-cell *matHeaderCellDef mat-sort-header>LAST NAME</th>
                <td mat-cell *matCellDef="let element"> {{element.therapistLastName}} </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>ACTIONS</th>
                <td mat-cell *matCellDef="let element">
                    
<!-- <button matTooltip="Edit therapist at event"
                        (click)="editTherapistAtEvent(element.therapistId);" mat-icon-button
                        aria-label="Edit therapist details">
                        <mat-icon>edit</mat-icon>
                    </button> -->

                    <button matTooltip="Remove therapist from event"
                        (click)="removeTherapistFromEvent(element.therapistId);" mat-icon-button
                        aria-label="Remove therapist from event">
                        <mat-icon>close</mat-icon>
                    </button>
                
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
    </div>
</div>
</div>
